<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">画像拡大</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="img_content">
          <img src="{{KYMW1602Model.goodsImage}}" #goodsImage>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" id="btn_ImageZoomClose" #btn_ImageZoomClose (click)="onClickClose()" forcedEnabledMode="true"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>